import React, { Component } from 'react';
import { Typography, Grid, Table, TableBody, TableRow, TableCell, TextField, Button, TableHead } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';
import PaddedGrid from '../components/PaddedGrid';
import APIService from '../services/APIService';
import { ALACARTE, BUFFET } from '../constants/RestaurantType';
import AppContext from '../AppContext';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            types: { 1: [], 2: [] },
            name: '',
            nameEn: '',
            loading: true
        };
    }

    addType(key) {
        APIService.storeFoodType({
            name: this.state.name,
            name_en: this.state.nameEn,
            type: key
        }).then((type) => {
            let types = this.state.types;
            types[key].push(type);

            this.setState({
                types,
                name: '',
                nameEn: ''
            });
        }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    removeType(typeKey, i) {
        let type = this.state.types[typeKey].splice(i, 1)[0];

        APIService.destroyFoodType(type.id)
            .then(() => {
                this.setState({ types: this.state.types });
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    componentDidMount() {
        APIService.getFoodTypes()
            .then((types) => {
                types = types.reduce((acc, type) => {
                    acc[type.type].push(type);
                    return acc;
                }, { 1: [], 2: [] });

                this.setState({
                    types,
                    loading: false
                });
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    render() {
        if (!AppContext.isAdmin()) {
            return (<Redirect to="/" />);
        }
        return (
            <PaddedGrid>
                <Grid item xs={12}>
                    <Typography variant="title">{this.props.t('Ruokakategoriat')}</Typography>
                </Grid>

                <Grid item xs={6}>
                    <Typography variant="subheading">{this.props.t('Annos')}</Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{this.props.t('Suomeksi')}</TableCell>
                                <TableCell>{this.props.t('Englanniksi')}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.types[ALACARTE].map((type, i) => (
                                <TableRow key={i}>
                                    <TableCell>{type.name}</TableCell>
                                    <TableCell>{type.name_en}</TableCell>
                                    <TableCell style={{ textAlign: 'right' }}>
                                        <Delete onClick={() => AppContext.prompt(() => this.removeType(ALACARTE, i))} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Typography variant="subheading" style={{ marginTop: "15px" }}>{this.props.t('Aterialajin nimi')}</Typography>
                    <Grid container spacing={24} style={{ marginTop: "5px" }}>
                        <Grid item xs={4}>
                            <TextField
                                style={{ width: "100%" }}
                                label={this.props.t('Suomeksi')}
                                value={this.state.name}
                                onChange={(event) => this.setState({ name: event.target.value })}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                style={{ width: "100%" }}
                                label={this.props.t('Englanniksi')}
                                value={this.state.nameEn}
                                onChange={(event) => this.setState({ nameEn: event.target.value })}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={() => this.addType(ALACARTE)}>
                                {this.props.t('Lisää')}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="subheading">{this.props.t('Linjasto')}</Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{this.props.t('Suomeksi')}</TableCell>
                                <TableCell>{this.props.t('Englanniksi')}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.types[BUFFET].map((type, i) => (
                                <TableRow key={i}>
                                    <TableCell>{type.name}</TableCell>
                                    <TableCell>{type.name_en}</TableCell>
                                    <TableCell style={{ textAlign: 'right' }}>
                                        <Delete onClick={() => AppContext.prompt(() => this.removeType(BUFFET, i))} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Typography variant="subheading" style={{ marginTop: "15px" }}>{this.props.t('Linjastolajin nimi')}</Typography>
                    <Grid container spacing={24} style={{ marginTop: "5px" }}>
                        <Grid item xs={4}>
                            <TextField
                                style={{ width: "100%" }}
                                label={this.props.t('Suomeksi')}
                                value={this.state.name}
                                onChange={(event) => this.setState({ name: event.target.value })}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                style={{ width: "100%" }}
                                label={this.props.t('Englanniksi')}
                                value={this.state.nameEn}
                                onChange={(event) => this.setState({ nameEn: event.target.value })}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={() => this.addType(BUFFET)}>
                                {this.props.t('Lisää')}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </PaddedGrid>
        );
    }
}

export default withTranslation()(Settings);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Settings.js